import { ToastMessageType } from "../components/toast/ToastContext";

export const ScenarioToasts = {
  scenarioCreated: {
    severity: "success",
    summary: "Szenario erstellt",
    detail: "Das Szenario wurde erfolgreich erstellt",
  } as ToastMessageType,
  scenarioCreationError: {
    severity: "error",
    summary: "Szenario-Erstellung fehlgeschlagen",
    detail: "Das Szenario konnte nicht durchgeführt werden",
  } as ToastMessageType,
  scenarioDeleted: {
    severity: "success",
    summary: "Szenario entfernt",
    detail: "Das Szenario wurde erfolgreich entfernt",
  } as ToastMessageType,
  scenarioDeletionError: {
    severity: "error",
    summary: "Szenario-Entfernung fehlgeschlagen",
    detail: "Das Szenario konnte nicht entfernt werden",
  } as ToastMessageType,
  scenarioModified: {
    severity: "success",
    summary: "Szenario bearbeitet",
    detail: "Die Änderungen an dem Szenario wurden erfolgreich gespeichert",
  } as ToastMessageType,
  scenarioModificationError: {
    severity: "error",
    summary: "Szenario-Bearbeitung fehlgeschlagen",
    detail: "Die Änderungen an dem Szenario konnten nicht gespeichert werden",
  } as ToastMessageType,
};
